import React from 'react';
import { useSelector } from 'react-redux';
import { selectUiMode } from '../../../Slices/mailUiSlice';
import MailRibbon from './MailRibbon';
import ComposeRibbon from './ComposeRibbon';

// ---------------------------------------------------------------------------
// Ribbon
//
// Smart switcher — reads uiMode from Redux and renders the correct ribbon.
//
// Props (all optional, forwarded to whichever ribbon is active):
//
//   MailRibbon props:
//     onOpenCompose   ({ type, message, conversationId }) => void
//
//   ComposeRibbon props:
//     onSend          () => void
//     onSaveDraft     () => void
//     onDiscard       () => void
//     onAttach        () => void
//     composeOptions  { showBcc, requestReadReceipt, requestDeliveryReceipt,
//                       importance, sensitivity }
//     onOptionsChange (newOptions) => void
//
//   Shared:
//     style           React.CSSProperties — forwarded to active ribbon root
// ---------------------------------------------------------------------------

export default function Ribbon({
  // MailRibbon
  onOpenCompose,
  // ComposeRibbon
  onSend,
  onSaveDraft,
  onDiscard,
  onAttach,
  composeOptions,
  onOptionsChange,
  // shared
  style,
}) {
  const uiMode = useSelector(selectUiMode);

  if (uiMode === 'compose') {
    return (
      <ComposeRibbon
        onSend={onSend}
        onSaveDraft={onSaveDraft}
        onDiscard={onDiscard}
        onAttach={onAttach}
        composeOptions={composeOptions}
        onOptionsChange={onOptionsChange}
        style={style}
      />
    );
  }

  // Default: 'mail' | 'search' | 'settings' — all show MailRibbon
  return (
    <MailRibbon
      onOpenCompose={onOpenCompose}
      style={style}
    />
  );
}
